"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const layout_css_1 = __importDefault(require("../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../styles/global_ui/util.css"));
const qAndAs = [
    {
        id: 'enter',
        question: 'How do I enter the Giveaway?',
        answer: 'To enter the Giveaway, you need to fill out the giveaway entry form. You will also need to verify your Hackster account. See official Terms & Conditions for details on what must be included in a valid entry and for full giveaway timeline and submission deadlines.',
    },
    {
        id: 'prize-preference',
        question: 'How do I choose my preferred prize(s)?',
        answer: 'When you register for the Giveaway, you will rank all of the prizes by preference. Prize winners are selected at random from the list of eligible entries received prior to each drawing period. Only one prize will be awarded per person, per household. If your name is drawn as a prize winner, your name will be removed from subsequent weekly prize drawings, but you will be eligible for the final grand prize Giveaway.',
    },
    {
        id: 'eligible',
        question: 'Who is eligible to participate?',
        answer: [
            '',
            'You must be at least the minimum age of majority in your place of residence at the time of entry.',
            'You must be a citizen of and reside in an eligible country. Please see the official rules for a complete list of eligible countries.',
            'You must not be involved in the execution or administration of this Giveaway or an immediate family member or household member of a Hackster or Avnet employee.',
        ],
    },
    {
        id: 'verification',
        question: 'Do I need to be a verified user?',
        answer: react_1.default.createElement(react_1.default.Fragment, null,
            "Yes, you must be a verified user before we can issue any prize. You can get verified by going to",
            ' ',
            react_1.default.createElement("a", { href: "/verify", rel: "noopener noreferrer", target: "_blank" }, "https://hackster.io/verify"),
            "."),
    },
    {
        id: 'won',
        question: 'How do I know if I won?',
        answer: 'Winners will be contacted via the email or address submitted in their entry within two (2) weeks of the completion of the Giveaway.',
    },
    {
        id: 'earn-entries',
        question: 'How do I earn Giveaway entries?',
        answer: [
            'You can earn Giveaway entries through website engagements, participating in competitions and challenges, and completing the other activities, including the answering questions in our survey(s).',
            'Daily Website Engagements: You earn up to five (5) entries max per day by doing one (1) action five (5) times or a mixture of all actions for five (5) total entries. Each of the following actions are worth one entry: liking a project, liking a news article, posting a discussion post, or posting a comment.',
            'Participating in Competitions and Challenges: You can submit a maximum of one (1) proposal per Challenge for five (5) entries per proposal. You can submit a maximum of one (1) hardware application for a Competition for five (5) entries per application. Each project submitted to a Competition or Challenge is worth ten (10) entries per submission. During the Giveaway, a user can earn a maximum of 30 entries for submitting projects to a Competition or Challenge.',
            'Publishing a Project: You can publish up to three (3) projects per day for ten (10) entries per project.',
            'Survey Responses: By completing a survey, you can earn five (5) entries max per submission.',
        ],
    },
];
const c = {
    container: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter22}`,
    header: `${typography_css_1.default.h2Responsive}`,
    list: `${util_css_1.default.ulReset} ${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter22}`,
    answer: `${typography_css_1.default.bodyL}`,
    question: `${typography_css_1.default.bodyXLResponsive} ${typography_css_1.default.bold}`,
    item: `${typography_css_1.default.bodyL}`,
};
const FaqTab = () => (react_1.default.createElement("div", { className: c.container },
    react_1.default.createElement("h2", { className: c.header }, "FAQs"),
    react_1.default.createElement("ul", { className: c.list }, qAndAs.map(({ answer, id, question }) => (react_1.default.createElement("li", { key: question, id: id },
        react_1.default.createElement("p", { className: c.question }, question),
        Array.isArray(answer)
            ? (react_1.default.createElement(react_1.default.Fragment, null,
                answer[0].length > 0 && (react_1.default.createElement("p", { className: c.answer }, answer[0])),
                react_1.default.createElement("ul", null, answer.slice(1).map((item) => (react_1.default.createElement("li", { key: item, className: c.item }, item))))))
            : (react_1.default.createElement("p", { className: c.answer }, answer))))))));
exports.default = FaqTab;
